import { useQueries } from "@tanstack/react-query";
import { AuthContext } from "context/AuthContext";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import getCsm from "service/user/parent/chat/get-csm";
import getTutors from "service/user/parent/chat/get-tutors";
import { db } from "../../firebase";
import { getDoc, doc } from "firebase/firestore";

import { collection, query, where, onSnapshot } from "firebase/firestore";
import { ChatContext } from "context/ChatContext";
import { useLocation } from "react-router-dom";

function ChatNotification() {
  const { authState } = useContext(AuthContext);
  const [count, setCount] = useState(0);
  const { data } = useContext(ChatContext);
  const userFbId = authState?.userInfo?.firebaseUid;
  const [csms, setCsms] = useState([]);
  const [tutors, setTutors] = useState([]);
  const location = useLocation();
  const [flag, setFlag] = useState(false);
  const [newMessage, setNewMessage] = useState(null);

  const queries = useQueries({
    queries: [
      {
        queryKey: ["csm-list"],
        queryFn: () => getCsm(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,
        onSuccess: (d) => {
          if (d && d.length > 0) {
            let list = [];

            list = d.filter((item) => {
              if (item.firebaseId) {
                return item.firebaseId;
              }
            });
            setCount((prev) => prev + 1);
            _loadUsers(list, "csm");
          }
        },
      },
      {
        queryKey: ["tutors-list"],
        queryFn: () => getTutors(authState?.userInfo?.cifNumber),
        enabled: !!authState?.userInfo?.cifNumber,
        onSuccess: (d) => {
          if (d && d.length > 0) {
            let list = [];
            list = d.filter((item) => {
              if (item.firebaseId) {
                return item.firebaseId;
              }
            });
            setCount((prev) => prev + 1);
            _loadUsers(list, "tutor");
          }
        },
      },
    ],
  });

  const _loadUsers = async (list, type) => {
    let nList = list.map((l) => l.firebaseId);
    let users = [];
    let newList = [];
    for (let i = 0; i < nList.length / 10; i++) {
      newList.push(
        nList.filter((l, ind) => {
          if (ind >= i * 10 && ind < (i + 1) * 10) {
            return l;
          }
        })
      );
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("uid", "in", newList[i]));
      const unsub = onSnapshot(q, (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push(doc.data());
        });
        let newUsers = [];
        users.map((user) => {
          let userId = user.uid;
          const id =
            userFbId > userId ? `${userFbId + userId}` : `${userId + userFbId}`;
          onSnapshot(doc(db, "lastMsg", id), (doc) => {
            let data = doc.data();
            newUsers = newUsers.filter(function (obj) {
              return obj.uid !== data?.from && obj.uid !== data?.to;
            });
            newUsers.push(data);
            if (
              // count === 0 &&
              data?.unread &&
              data?.to === userFbId &&
              formatAMPM(data?.createdAt.toDate()) === formatAMPM(new Date()) &&
              formatDate(data?.createdAt?.toDate()) === formatDate(new Date())
            ) {
              console.log("New message displaying...");
              setNewMessage({ name: user.name, message: data?.message });
              setTimeout(() => setNewMessage(false), 2000);
              return () => unsub();
            }
            if (newUsers?.length === users.length || !flag) {
              newUsers.map((u) => {
                if (u?.unread && !flag && u?.to === userFbId) {
                  setFlag(true);
                }
              });
            }
          });
          // return () => unsub2();
        });
      });
      // return () => unsub();
    }
  };

  function formatAMPM(date) {
    if (date) {
      var hours = date?.getHours();
      var minutes = date?.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime.toUpperCase();
    }
  }

  function formatDate(date) {
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    let today = new Date();
    if (
      date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear()
    )
      return "Yesterday";
    else if (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    )
      return "Today";
    else return date.toLocaleDateString();
  }

  const showNotification = (title, body) => {
    const notification = new Notification(title, {
      body: body,
    });
  };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const loggedIn = urlParams.get("l");
    if (flag && loggedIn === "1")
      if (location.pathname === "/") {
        if (Notification.permission === "granted") {
          showNotification(
            "You have new unread messages",
            "Click on chat to view them!"
          );
        } else if (Notification.permission !== "denied") {
          Notification.requestPermission().then((permission) => {
            showNotification(
              "You have new unread messages",
              "Click on chat to view them!"
            );
          });
        }
        setCount((prev) => prev + 1);
      }
  }, [flag]);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const loggedIn = urlParams.get("l");
    if (newMessage && loggedIn !== "1")
      if (location.pathname !== "/chat") {
        if (Notification.permission === "granted") {
          showNotification(newMessage.name, newMessage.message);
        } else if (Notification.permission !== "denied") {
          Notification.requestPermission().then((permission) => {
            showNotification(newMessage.name, newMessage.message);
          });
        }
      } else {
        setNewMessage(false);
      }
    else {
      setNewMessage(false);
    }
  }, [newMessage, setNewMessage]);

  return <></>;
}

export default ChatNotification;
